import { Injectable } from '@angular/core';
import { KushkiPayment, KushkiPaymentApiItem, KushkiPaymentDetail } from '../../domain/models/kushki.model';

@Injectable({
    providedIn: 'root'
})
export class KushkiPaymentsMapperService {

    mapFromApi(item: KushkiPaymentApiItem): KushkiPayment {
        return {
            recordId: item?.recordId,
            nombre: item?.nombre,
            dni: item?.dni,
            amount: Number(item?.monto),
            code: this.getCodeDescription(item?.codigo),
            codeDescription: item?.codigoDescripcion,
            registrationDate: this.toLocalDate(item?.fechaRegistro),
            detail: this.parseDetail(item?.detalle),
            kushkiError: item?.detalleKushkiError
        };
    }

    mapKushkiResponse(items: KushkiPaymentApiItem[]): KushkiPayment[] {
        return items.map(item => this.mapFromApi(item));
    }

    private parseDetail(detail: string): KushkiPaymentDetail | null {
        if (!detail) return null;

        try {
            const parsed = JSON.parse(detail);
            return {
                code: parsed?.code ?? '',
                message: parsed?.message ?? '',
                processorError: parsed?.processorError ?? '',
                ticketNumber: parsed?.ticketNumber ?? 'vacío'
            };
        } catch {
            return null;
        }
    }

    getCodeDescription(code: string): string {
        if (!code) return 'Código desconocido';
        return code === '000' ? 'Aprobada' : code;
    }

    /** `yyyy-MM-dd` se arma en local: `new Date()` lo toma como UTC y en Perú resta un día. */
    private toLocalDate(value: unknown): Date {
        if (typeof value !== 'string') return new Date(`${value}`);

        const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
        if (!dateOnly) return new Date(value);

        return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
    }

}
